import * as THREE from "three";

const materials = [

  {
    id: "M_EnviroDome",
    type: "DomeMaterial",
    map: "{context.tractor.state.environment}",
  },
  {
    id: "M_Spot",
    type: "SpriteMaterial",
    map: "T_Spot",
    alphaTest: 0.1,
  },
  {
    id: "M_Spot_Active",
    type: "SpriteMaterial",
    map: "T_Spot_Active",
    alphaTest: 0.1,
  },
  {
    id: "M_Spot_Action",
    type: "SpriteMaterial",
    map: "T_Spot_Action",
    alphaTest: 0.1,
  },
  {
    id: "M_Spot_Toggle",
    type: "SpriteMaterial",
    map: "T_Spot_Toggle",
    alphaTest: 0.1,
  },
  {
    id: "M_Spot_Toggle_Active",
    type: "SpriteMaterial",
    map: "T_Spot_Toggle_Active",
    alphaTest: 0.1,
  },
  {
    id: "M_Spot_Service",
    type: "SpriteMaterial",
    map: "T_Spot_Service",
    alphaTest: 0.1,
  },
  {
    id: "M_Spot_Service_Active",
    type: "SpriteMaterial",
    map: "T_Spot_Service_Active",
    alphaTest: 0.1,
  },
  {
    // NS Null matsku, käytössä kaikkialla oletuksena.
    id: "M_Main",
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
    metalness: 0,
    roughness: 0.3,
    color: 0xcccccc,
  },
  {
    // Base parameters for all car paints
    id: "M_CarPaint",
    //Green child start
    // color: 0x425100,
    parent: "{context.tractor.state.color}",
    //Green child End
    clearcoat: 1,
    clearcoatRoughness: 0.09,
    reflectivity: 0.7,
    roughness: 0.09,
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.5,
  },
/*   {
    id: "black-metallic",
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.5,
    //metalness: 0.65,
    map: "T_Unlimited_Pattern",
    metalness: 0,
    //normalMap: "flakes",
    //normalScale: [0.03, 0.03],
    color: 0xFFFFFF,
  }, */
  {
    id: "black-metallic",
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.5,
    //metalness: 0.65,
    metalness: 0.7,
    normalMap: "flakes",
    normalScale: [0.03, 0.03],
    color: 0x464646,
  }, 
  {
    id: "blue-metallic",
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.5,
    //metalness: 0.45,
    metalness: 0.7,
    normalMap: "flakes",
    normalScale: [0.03, 0.03],
    color: 0x0D5F84,
  },
  {
    id: "bronze-metallic",
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.5,
    color: 0x9b6a4b,
    //metalness: 0.7,
    metalness: 0.7,
    normalMap: 'flakes',
    normalScale: [0.03, 0.03],
  },
  {
    id: "olive-green-metallic",
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.5,
    //metalness: 0.45,
    metalness: 0.65,
    normalMap: "flakes",
    normalScale: [0.03, 0.03],
    //color: 0x6B633D,
    color: 0x425100,
  },
  {
    id: "red",
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.1,
    //color: 0x9D383F,
    color: 0xd81413,
    metalness: 0,
    normalMap: null,
  },
  {
    id: "red-metallic",
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.5,
    //metalness: 0.65,
    metalness: 0.7,
    normalMap: "flakes",
    normalScale: [0.03, 0.03],
    color: 0x7b2020,
  },
  {
    id: "white-metallic",
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.5,
    metalness: 0.1,
    normalMap: "flakes",
    normalScale: [0.03, 0.03],
    color: 0xF6F6F2,
  },
  {
    id: "M_AGCO_Gray",
    color: 0x56555a,
    roughness: 0.33,
    metalness: 0.1,
    metalnessMap: "T_Grime_2",
    bumpMap: "T_Grime_2",
    bumpScale: 0.0003,
    type: "MeshPhysicalMaterial",
    // // envMapIntensity: 0.2,
  },
  {
    id: "MI_Orange_Paint",
    parent: "M_AGCO_Gray",
    color: 0xd06500,
  },
  {
    id: "M_AGCO_Gray_Smooth",
    color: 0x56555a,
    roughness: 0.33,
    metalness: 0.1,
    metalnessMap: "T_Grime_2",
    bumpMap: "T_Grime_2",
    bumpScale: 0.0001,
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_PaintedMetal",
    color: 0x111111,
    roughness: 0.2,
    reflectivity: 0.3,
    clearcoat: 1,
    clearcoatRoughness: 0.34,
    metalness: 0,
    bumpMap: "flakes",
    bumpScale: 0.0001,
    type: "MeshPhysicalMaterial",
    //// envMapIntensity: 0.6,
  },
  {
    id: "M_Matt",
    color: 0x000000,
    roughness: 1,
    reflectivity: 0.3,
    metalness: 0,
  },
  {
    id: "MI_PaintedMetal_Black",
    parent: "M_PaintedMetal",
    color: 0x111111,
    roughness: 0.2,
    clearcoat: 1,
    clearcoatRoughness: 0.24,
    // envMapIntensity: 0.5
  },
  {
    id: "MI_PaintedMetal_Yellow",
    parent: "M_PaintedMetal",
    color: 0xf9c126,
    roughness: 0.2,
    clearcoat: 1,
    clearcoatRoughness: 0.24,
    // envMapIntensity: 0.1
  },
  {
    id: "MI_PaintedMetal_White",
    parent: "M_PaintedMetal",
    color: 0xf3f3f3,
    roughness: 0.2,
    clearcoat: 1,
    clearcoatRoughness: 0.24,
    // envMapIntensity: 0.1
  },
  {
    id: "MI_PaintedMetal_White_Rim_N",
    parent: "{context.tractor.state.wheelColor}",
    //parent: "M_PaintedMetal",
    map: "N_Tyres_AO",
    aoMap: "N_Tyres_AO",
    reflectivity: 0.3,
    clearcoat: 1,
    clearcoatRoughness: 0.34,
    metalness: 0,
    bumpMap: "flakes",
    bumpScale: 0.0001,
    type: "MeshPhysicalMaterial",
    //lightMap: "N_Tyres_AO",
    //lightMapIntensity: 0.5,
  },
  {
    id: "MI_PaintedMetal_White_Rim_T",
    parent: "{context.tractor.state.wheelColor}",
    map: "T_Tyres_AO",
    aoMap: "T_Tyres_AO",
    reflectivity: 0.3,
    clearcoat: 1,
    clearcoatRoughness: 0.34,
    metalness: 0,
    bumpMap: "flakes",
    bumpScale: 0.0001,
    type: "MeshPhysicalMaterial",
  },
  {
    id: "white-wheel",
    //parent: "M_PaintedMetal",
    color: 0xf3f3f3,
    roughness: 0.2,
    clearcoatRoughness: 0.24,
    // envMapIntensity: 0.1
  },
  {
    id: "black-wheel",
    //parent: "M_PaintedMetal",
    color: 0x111111,
    roughness: 0.2,
    // envMapIntensity: 0.1
  },
  {
    id: "MI_PaintedMetal_White_Rim_A",
    parent: "M_PaintedMetal",
    map: "T_Tyres_A_AO",
    color: 0xf3f3f3,
    roughness: 0.2,
    clearcoat: 1,
    clearcoatRoughness: 0.24,
    aoMap: "T_Tyres_A_AO",
 /*    lightMap: "T_Tyres_A_AO",
    lightMapIntensity: 0.5, */
  },
  {
    id: "M_Emissive",
    color: 0xffffff,
    roughness: 0,
    metalness: 0,
    map: "T_Light_Strip",
    //emissive: 0xFFFFFF,
    //emissivemap: "T_Light_Strip",
  },
  {
    id: "M_Glass",
    color: 0x555555,
    roughness: 0.05,
    metalness: 0,
    depthWrite: false,
    transmission: 0.75,
    reflectivity: 0.5,
    ior: 1.6,
    opacity: 1,
    transparent: true,
    side: THREE.DoubleSide,
    type: "MeshPhysicalMaterial",
    envMapIntensity: 1,
  },
  {
    id: "M_Blinker_Glass_Orange",
    //parent: "M_Glass",
    color: 0xed6c18,
    roughness: 0.05,
    metalness: 0,
    transmission: 0.25,
    reflectivity: 0.5,
    ior: 1.6,
    opacity: 1,
    transparent: true,
    side: THREE.DoubleSide,
    type: "MeshPhysicalMaterial",
  },
  {
    id: "M_Blinker_Glass_Clear",
    //parent: "M_Glass",
    color: 0x555555,
    roughness: 0.01,
    metalness: 0,
    transmission: 0.35,
    reflectivity: 0.5,
    ior: 1.6,
    opacity: 1,
    transparent: true,
    side: THREE.DoubleSide,
    type: "MeshPhysicalMaterial",
  },
  {
    id: "M_MeshGrill",
    color: 0x000000,
    roughness: 0.45,
    metalness: 0,
    bumpMap: "T_Round_Grid",
    bumpScale: 0.001,
    transparent: true,
    zWrite: false,
    alphaMap: "T_Round_Grid_O",
    // Dev Note: Double side not working same way on some mobile devices
    // side: THREE.DoubleSide,
  },
  {
    id: "M_Rubber_Black",
    color: 0x27282a,
    roughness: 0.4,
    metalness: 0,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.1,
    skinning: true,
  },
  {
    id: "M_M219VV2550110",
    parent: "M_Rubber_Black",
    normalMap: "T_M219VV2550110_N",
    normalScale: [-1, -1],
  },
  {
    id: "M_Projector_Lens",
    color: 0xffffff,
    map: "T_Projector_lens",
    //emissive: 0xFFFFFF,
    //emissivemap: "T_Projector_lens",
    roughness: 0,
    metalness: 1,
    type: "MeshStandardMaterial",
    // envMapIntensity: 1,
  },
  {
    id: "M_Hella_SML_MD1224",
    color: 0xffffff,
    map: "T_Hella_SML_MD1224",
    roughness: 0,
    metalness: 0,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Sunscreen_mesh",
    color: 0x000000,
    roughness: 0.75,
    metalness: 0,
    depthWrite: false,
    //transmission: 0.2,
    //reflectivity: 0.5,
    //ior: 1.6,
    opacity: 0.9,
    transparent: true,
    depthWrite: false,
    //side: THREE.DoubleSide,
    alphaMap: "T_Round_Grid_O",
    //alphaMap: "T_Round_Grid",
    type: "MeshPhysicalMaterial",
  },
  {
    id: "M_Felt",
    color: 0x53575f,
    //color: 0xFF0000,
    map: "T_Felt",
    roughness: 0.8,
    metalness: 0,
    //roughnessMap: 'T_Grime_1_lite',
    bumpMap: "T_Felt",
    bumpScale: 0.0005,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Felt_white",
    color: 0xffffff,
    map: "T_Felt",
    roughness: 0.8,
    metalness: 0,
    //roughnessMap: 'T_Grime_1_lite',
    bumpMap: "T_Felt",
    bumpScale: 0.0005,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Felt_white_A",
    color: 0xffffff,
    map: "T_Felt",
    roughness: 0.8,
    metalness: 0,
    //roughnessMap: 'T_Grime_1_lite',
    bumpMap: "T_Felt",
    bumpScale: 0.0005,
    aoMap: "T_Felt_White_A_AO",
    lightmap: "T_Felt_White_A_AO",
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Felt_white_N_T",
    color: 0xffffff,
    map: "T_Felt",
    roughness: 0.8,
    metalness: 0,
    //roughnessMap: 'T_Grime_1_lite',
    bumpMap: "T_Felt",
    bumpScale: 0.0005,
    aoMap: "T_Felt_White_N_T_AO",
    lightmap: "T_Felt_White_N_T_AO",
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Pantone_431",
    color: 0x5b6770,
    roughness: 0.65,
    metalness: 0,
    bumpMap: "T_flakes_75_75",
    bumpScale: 0.00009,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Pantone_433",
    color: 0x24292e,
    roughness: 0.65,
    metalness: 0,
    bumpMap: "T_flakes_75_75",
    bumpScale: 0.00009,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Plastic",
    color: 0x39393a,
    roughness: 0.4,
    metalness: 0,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.1,
  },
  {
    id: "M_Light_Control_Panel",
    parent: "M_Plastic",
    emissive: 0xffffff,
    emissiveMap: "T_Light_Control_Panel",
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_MVHS320BT",
    parent: "M_Plastic",
    emissive: 0xffffff,
    emissiveMap: "T_MVHS320BT",
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Speaker_Grid",
    parent: "M_Plastic",
    roughness: 0.6,
    bumpMap: "T_Speaker_Grid_B",
    bumpScale: 0.002,
    alphaMap: "T_Speaker_Grid_O",
    transparent: true,
  },
  {
    id: "M_Speaker_Element",
    map: "T_Speaker_B",
    color: 0x7d7d7d,
    roughness: 0.5,
    metalness: 0,
  },
  {
    id: "MI_Plastic_Black_Textured",
    parent: "M_Plastic",
    bumpMap: "T_flakes_150_150",
    bumpScale: 0.00018,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_White_Textured",
    parent: "M_Plastic",
    color: 0xe1e1e1,
    bumpMap: "T_flakes_150_150",
    bumpScale: 0.00018,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_Black",
    parent: "M_Plastic",
    bumpMap: "T_flakes_150_150",
    bumpScale: 0.00009,
    roughness: 0.3,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Interior_Plastic_Gray",
    color: 0x7f8b8e,
    parent: "M_Plastic",
    bumpMap: "T_flakes_150_150",
    bumpScale: 0.00009,
    roughness: 0.35,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Interior_Plastic_Gray_A",
    color: 0x7f8b8e,
    parent: "M_Plastic",
    //bumpMap: "T_flakes_150_150",
    //bumpScale: 0.0009,
    // bump mapin tieltys ei toimi koska ao mapin tiletys ylikirjoittaa sen
    roughness: 0.45,
    map: "T_Interior_Plastic_Gray_A_AO",
    aoMap: "T_Interior_Plastic_Gray_A_AO",
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Interior_Black_Carbon_Fiber_Vinyl",
    parent: "M_Plastic",
    bumpMap: "T_Carbon",
    bumpScale: 0.0001,
    roughness: 0.2,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Leather",
    bumpMap: "T_Leather_1",
    color: 0x232323,
    metalness: 0,
    bumpScale: 0.00007651,
    roughness: 0.5,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_AdBlue",
    color: 0x00aeda,
    parent: "M_Plastic",
    roughness: 0.2,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_Yellow",
    color: 0xffd800,
    parent: "M_Plastic",
    roughness: 0.2,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_Red",
    color: 0xb40b17,
    parent: "M_Plastic",
    roughness: 0.33,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_Blue",
    color: 0x0000ff,
    parent: "M_Plastic",
    roughness: 0.2,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_Blue_2",
    color: 0x336bf0,
    parent: "M_Plastic",
    roughness: 0.2,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_Brown",
    color: 0x7e634e,
    parent: "M_Plastic",
    roughness: 0.2,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_Brown_2",
    color: 0x6d5c55,
    parent: "M_Plastic",
    roughness: 0.2,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_Green",
    color: 0x00ff00,
    parent: "M_Plastic",
    roughness: 0.2,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_Green_2",
    color: 0x4b7c5e,
    parent: "M_Plastic",
    roughness: 0.2,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_White",
    color: 0xffffff,
    parent: "M_Plastic",
    roughness: 0.2,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Plastic_Orange",
    color: 0xfc9a00,
    parent: "M_Plastic",
    bumpScale: 0.000005,
    roughness: 0.25,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Chrome",
    color: 0xffffff,
    envMapIntensity: 1.2,
    roughness: 0.05,
    metalness: 1,
    type: "MeshPhysicalMaterial",
  },
  {
    id: "M_Bolt",
    parent: "M_Chrome",
    normalMap: "T_Bolt_N",
    color: 0x505050,
    roughness: 0.3,
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Aluminum",
    color: 0xc4c4c4,
    roughness: 0.5,
    roughnessMap: "T_Grime_1_lite",
    metalness: 1,
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Brass",
    color: 0xa79b76,
    roughness: 0.3,
    roughnessMap: "T_Grime_1_lite",
    metalness: 1,
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Radiator",
    parent: "M_Aluminum",
    map: "T_Radiator",
  },
  {
    id: "M_Hella_Rotaled",
    map: "T_Hella_Rotaled",
    color: 0xffffff,
    metalness: 0,
    roughness: 0.1,
    transmission: 0.1,
    reflectivity: 0.5,
    ior: 1.6,
    opacity: 1,
    type: "MeshPhysicalMaterial",
    transparent: true,
  },
  {
    id: "M_Blinker_Chrome",
    parent: "M_Chrome",
    color: 0xed6c18,
  },
  {
    id: "M_Tail_Light_Chrome",
    parent: "M_Chrome",
    color: 0xff0000,
  },
  {
    id: "M_tail_light_Chrome_textured",
    parent: "M_Chrome",
    bumpMap: "flakes",
    bumpScale: 0.00003,
    color: 0xff0000,
  },
  {
    id: "M_Tail_Light_Lens_In_Textured",
    map: "T_Tail_Light_lens",
    color: 0xffffff,
    metalness: 0,
    roughness: 0.05,
    transmission: 0.35,
    reflectivity: 0.5,
    ior: 1.6,
    opacity: 1,
    type: "MeshPhysicalMaterial",
    transparent: true,
  },
  {
    id: "M_Tail_Light_Lens_In_Clear",
    color: 0xff0000,
    metalness: 0,
    roughness: 0.05,
    transmission: 0.35,
    reflectivity: 0.5,
    ior: 1.6,
    opacity: 1,
    type: "MeshPhysicalMaterial",
    transparent: true,
  },
  {
    id: "M_Tail_Light_Lens_Out_Red",
    color: 0x751f23,
    metalness: 0,
    roughness: 0.05,
    transmission: 0.35,
    reflectivity: 0.5,
    ior: 1.6,
    opacity: 1,
    type: "MeshPhysicalMaterial",
    transparent: true,
  },
  {
    id: "M_Aux_Light_Lens",
    color: 0xffffff,
    map: "T_Tyri_Aux_light_lens",
    roughness: 0.05,
    metalness: 0.3,
    emissiveMap: "T_Tyri_Aux_light_lens",
    emissive: 0xffffff,
    emissiveIntensity: 0.3,
  },
  {
    id: "M_Rear_reflector",
    color: 0xff0000,
    map: "T_Tyri_Aux_light_lens",
    roughness: 0.05,
    metalness: 0,
    reflectivity: 0.5,
    ior: 1.6,
    emissiveMap: "T_Tyri_Aux_light_lens",
    emissive: 0xff0000,
    emissiveIntensity: 0.3,
  },
  {
    id: "M_Window_Frame_In",
    color: 0x000000,
    roughness: 0.45,
    metalness: 0,
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Window_Frame_Out",
    color: 0x000000,
    roughness: 0,
    metalness: 0,
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Wheel_Threads",
    parent: "M_Aluminum",
    roughness: 0.2,
    bumpMap: "T_checker_BW_treads",
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Instrument_Cluster",
    roughness: 0.1,
    metalness: 0,
    color: 0x000000,
    emissive: 0xffffff,
    emissiveMap: "T_Instrument_Cluster",
    emissiveIntensity: 1,
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Screen_1",
    roughness: 0.1,
    metalness: 0,
    color: 0x000000,
    emissive: 0xffffff,
    emissiveMap: "T_activehitec_screen",
    emissiveIntensity: 1,
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Screen_2",
    roughness: 0.1,
    metalness: 0,
    color: 0x000000,
    emissive: 0xffffff,
    emissiveMap: "T_Valtra_Home",
    emissiveIntensity: 1,
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Screen_Bezel",
    roughness: 0.1,
    metalness: 0,
    color: 0x000000,
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Steeringwheel",
    roughness: 1,
    metalness: 0,
    map: "T_Steeringwheel_B",
    roughnessMap: "T_Steeringwheel_R",
    normalMap: "T_Steeringwheel_N",
    normalScale: [-1, -1],
    type: "MeshPhysicalMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Seatbelt",
    color: 0x222222,
    map: "T_Carbon",
    roughness: 0.85,
    metalness: 0.1,
    //roughnessMap: 'T_Grime_1_lite',
    bumpMap: "T_Carbon",
    bumpScale: 0.001,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
    skinning: true,
  },
  {
    id: "M_Seatbelt_Interior",
    color: 0x222222,
    map: "T_Carbon",
    roughness: 0.85,
    metalness: 0.1,
    //roughnessMap: 'T_Grime_1_lite',
    bumpMap: "T_Carbon",
    bumpScale: 0.001,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
    skinning: true,
  },
/*   {
    id: "M_Aux_Seat",
    color: 0xffffff,
    map: "T_Fabric_Aux_Seat",
    roughness: 1,
    metalness: 0,
    bumpMap: "T_Fabric_Aux_Seat",
    bumpScale: 0.002,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.05,
  }, */
  {
    id: "M_Fabric",
    color: 0x6e6e6e,
    map: "T_Fabric",
    roughness: 0.75,
    metalness: 0,
    bumpMap: "T_Fabric",
    bumpScale: 0.00008,
    type: "MeshStandardMaterial",
  },
  {
    id: "M_Valtra_Stich",
    color: 0xa7a5a5,
    //map: 'T_Fabric',
    roughness: 0.75,
    metalness: 0,
    bumpMap: "T_Fabric",
    bumpScale: 0.00008,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Seat_Main",
    color: 0xffffff,
    roughness: 1,
    metalness: 1,
    map: "T_Seat_Main_B",
    roughnessMap: "T_Seat_Main_ORM",
    metalnessMap: "T_Seat_Main_ORM",
    aoMap: "T_Seat_Main_ORM",
    normalMap: "T_Seat_Main_N",
    normalScale: [-1, -1],
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Battery_Label",
    color: 0xffffff,
    roughness: 0.3,
    metalness: 0,
    map: "T_Battery",
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Brake_label",
    color: 0xffffff,
    roughness: 0.3,
    metalness: 0,
    map: "T_Brake_label",
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Flag",
    color: 0xffffff,
    map: "Flag_B",
    roughness: 1,
    metalness: 0,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Tyre_Front",
    color: 0xffffff,
    roughness: 1,
    metalness: 0,
    map: "T_Tyres_Front_A_B",
    roughnessMap: "T_Tyres_Front_ORM",
    //metalnessMap: "T_Tyres_Front_ORM",
    aoMap: "T_Tyres_AO",
    normalMap: "T_Tyres_Front_N",
    normalScale: [-1.3, -1.3],
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_Tyre_Back",
    color: 0xffffff,
    roughness: 1,
    metalness: 0,
    map: "T_Tyres_Front_A_B",
    roughnessMap: "T_Tyres_Back_ORM",
    //metalnessMap: "T_Tyres_Back_ORM",
    aoMap: "T_Tyres_AO",
    normalMap: "T_Tyres_Back_N",
    normalScale: [-1.3, -1.3],
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "MI_Tyre_Front_A",
    parent: "M_Tyre_Front",
    map: "T_Tyres_Front_A_B",
    roughnessMap: "T_Tyres_Front_A_ORM",
    aoMap: "T_Tyres_A_AO",
    normalMap: "T_Tyres_Front_A_N",
    normalScale: [-1.3, -1.3],
  },
  {
    id: "MI_Tyre_Back_A",
    parent: "M_Tyre_Back",
    map: "T_Tyres_Front_A_B",
    roughnessMap: "T_Tyres_Back_A_ORM",
    aoMap: "T_Tyres_A_AO",
    normalMap: "T_Tyres_Back_A_N",
    normalScale: [-1.3, -1.3],
  },
  {
    id: "M_Tyre_Mitas_AC65",
    color: 0x1a1a1a,
    roughness: 0.5,
    metalness: 0,
    map: "T_AC65_ORM",
    roughnessMap: "T_AC65_ORM",
    normalMap: "T_AC65_N",
    aoMap: "T_AC65_ORM",
    //normalScale: [-1.3, -1.3],
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
  {
    id: "M_ACX3203580_GFX_2",
    color: 0xFFFFFF,
    roughness: 0.34,
    metalness: 0,
    map: "T_ACX3203580_GFX_2",
    type: "MeshStandardMaterial",
  },
  {
    id: "M_Ground_Plane",
    color: 0x000000,
    roughness: 1,
    metalness: 0,
    alphaMap: "T_Ground_Plane_O",
    transparent: true,
    type: "MeshStandardMaterial",
    // envMapIntensity: 0.15,
  },
];

export default materials;
